import ICustomer from "./ICustomer";
import ClientType from "@/module/main/dto/ClientTypeEnum";

export default class Customer implements ICustomer
{
    public readonly type: ClientType;
    public readonly entrepreneur?: object;
    public readonly legalEntity?: object;
    public readonly person?: object;

    constructor(props: ICustomer)
    {
        this.type = props.type;
        this.entrepreneur = props.entrepreneur;
        this.legalEntity = props.legalEntity;
        this.person = props.person;
    }
}
